import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Components
import { Illustrations } from 'Wpds/components/illustration';
import BaseCta, { BaseCtaShowProps } from './BaseCta';

// Styles
import './BaPending.scss';

// Hooks
import { handleLaunchExternalLink } from 'Shared/utils/external-link';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';

interface Props extends BaseCtaShowProps {
  user: User;
}

const BaPending = ({ user, ...rest }: Props) => {
  const { getBaUrl, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: true });
  const { trackRestartAssessmentButtonClick } = useBaTracking();

  const handleButtonClick = async () => {
    trackRestartAssessmentButtonClick();
    const url = await getBaUrl();
    handleLaunchExternalLink({ href: url });
  };

  return (
    <BaseCta
      title="Pending assessment completion."
      description="Already completed? Refresh the page to see your results."
      showDescription={true}
      illustration={Illustrations.hourglass}
      illustrationName="hourglass"
      buttonConfirmationText="Need to restart?"
      buttonText="Restart the assessment"
      onButtonClick={handleButtonClick}
      showDivider={false}
      showExternalLink={false}
      loading={isCreatingBaLink}
      buttonSize="md"
      buttonVariant="secondary"
      {...rest}
    />
  );
};

export default BaPending;
